export const BANK_FEED_MBB_ACCOUNT = {
    id: 48,
    code: "1004",
    name: "Maybank Savings 8348",
    description: null,
    currency_code: "MYR",
    currency: {
        code: "MYR",
        symbol: "RM",
        name: "Malaysian Ringgit",
    },
    balance: 0,
    reconciled_date: null,
    reconciled_balance: 0,
    type: "current_assets",
    parent_id: null,
    system_type: "bank_cash",
    is_deletable: true,
    is_locked: false,
    is_archived: false,
    created_at: "2023-08-10 16:56:44",
    updated_at: "2023-08-10 16:56:44",

    // NEW KEYS IN STRUCTURE
    // bank_code: 'MBB',
    // bank_account_name: 'Maybank i-Saver 1241',
    // bank: 'Maybank2U',
    // integration_status: 'CONNECTED',
    // bank_feed_last_sync_at: '2023-11-06 16:56:44',

    // New Keys after revised by Jye (Nov 14)
    bank_feed_id: 1,
    // ext_account_id: '1241',
    bank_feed_account_id: 1,
    sync_starts_at: '2023-10-16 16:56:44',
    sync_ends_at: '2023-11-18 16:56:44',

    // account_number: '1122334455668348',
    // last_sync_at: '2023-11-06 16:56:44',
};
